import { lazy } from 'react';

import ContactView from '@/views/contact/Contact.view.tsx';

import { RouteEnum, RouteModel } from './Route.model';
import { ROUTES_PERMISSIONS, ROUTES_ROLES } from './routesPermissions.model.ts';

const AdminPanelView = lazy(() => import('@/views/adminPanel/AdminPanel.view'));
const ForbiddenView = lazy(() => import('@/views/generalError/forbidden/Forbidden.comp'));
const NotificationsView = lazy(() => import('@/views/notifications/Notifications.view'));
const LandingPageView = lazy(() => import('@/views/landingPage/LandingPage.view'));
const NewsArticlesView = lazy(() => import('@/views/landingPage/NewsArticles.view'));
const SuccessionView = lazy(() => import('@/views/succession/Succession.view'));
const SuccessionChangelogView = lazy(
  () => import('@/views/successionChangelog/SuccessionChangelog.view'),
);
const OrganizationChartView = lazy(
  () => import('@/views/organizationChart/OrganizationChart.view'),
);
const NestedStructureView = lazy(() => import('@/views/nestedStructure/NestedStructure.view'));
const MyProfileView = lazy(() => import('@/views/myProfile/MyProfile.view'));
const EmployeeProfileNewView = lazy(
  () => import('@/views/employeeProfileNew/EmployeeProfileNew.view'),
);
const SurveyFillView = lazy(() => import('@/views/surveyFill/SurveyFill.view'));
const SurveySummaryView = lazy(() => import('@/views/surveyFill/SurveySummary.view'));
const CertificationView = lazy(() => import('@/views/certification/Certification.view'));
const TestFillView = lazy(() => import('@/views/testFill/TestFill.view'));
const TestTermUnavailableView = lazy(() => import('@/views/testFill/TestTermUnavailable.view'));
const TestResultView = lazy(() => import('@/views/testResult/TestResult.view'));
const ExamineeExamView = lazy(() => import('@/views/examineeExam/ExamineeExam.view'));
const TeamView = lazy(() => import('@/views/team/TeamView.view'));
const AreaView = lazy(() => import('@/views/area/AreaView.view'));

export const ROUTES: RouteModel[] = [
  {
    component: LandingPageView,
    path: RouteEnum.ROOT,
    permissions: ROUTES_PERMISSIONS[RouteEnum.ROOT],
  },
  {
    component: TeamView,
    path: RouteEnum.TEAM,
    permissions: ROUTES_PERMISSIONS[RouteEnum.TEAM],
  },
  {
    component: AreaView,
    path: RouteEnum.AREA,
    permissions: ROUTES_PERMISSIONS[RouteEnum.AREA],
    roles: ROUTES_ROLES[RouteEnum.AREA],
  },
  {
    component: NewsArticlesView,
    path: RouteEnum.NEWS,
    permissions: ROUTES_PERMISSIONS[RouteEnum.NEWS],
  },
  {
    component: MyProfileView,
    path: RouteEnum.MY_PROFILE,
    permissions: ROUTES_PERMISSIONS[RouteEnum.MY_PROFILE],
  },
  {
    component: EmployeeProfileNewView,
    path: RouteEnum.EMPLOYEE_PROFILE_NEW,
    permissions: ROUTES_PERMISSIONS[RouteEnum.EMPLOYEE_PROFILE_NEW],
  },
  {
    component: AdminPanelView,
    path: RouteEnum.ADMIN,
    permissions: ROUTES_PERMISSIONS[RouteEnum.ADMIN],
  },
  {
    component: NotificationsView,
    path: RouteEnum.NOTIFICATIONS,
    permissions: ROUTES_PERMISSIONS[RouteEnum.NOTIFICATIONS],
  },
  {
    component: ContactView,
    path: RouteEnum.CONTACT,
    permissions: ROUTES_PERMISSIONS[RouteEnum.CONTACT],
  },
  {
    component: SuccessionView,
    path: RouteEnum.SUCCESSION,
    permissions: ROUTES_PERMISSIONS[RouteEnum.SUCCESSION],
  },
  {
    component: SuccessionChangelogView,
    path: RouteEnum.SUCCESSION_CHANGELOG,
    permissions: ROUTES_PERMISSIONS[RouteEnum.SUCCESSION_CHANGELOG],
  },
  {
    component: OrganizationChartView,
    path: RouteEnum.ORGANIZATION_CHART,
    permissions: ROUTES_PERMISSIONS[RouteEnum.ORGANIZATION_CHART],
  },
  {
    component: NestedStructureView,
    path: RouteEnum.NESTED_STRUCTURE,
    permissions: ROUTES_PERMISSIONS[RouteEnum.NESTED_STRUCTURE],
  },
  {
    component: CertificationView,
    path: RouteEnum.CERTIFICATION,
    permissions: ROUTES_PERMISSIONS[RouteEnum.CERTIFICATION],
  },
  {
    component: SurveyFillView,
    path: RouteEnum.SURVEY_FILL,
    permissions: ROUTES_PERMISSIONS[RouteEnum.SURVEY_FILL],
  },
  {
    component: SurveySummaryView,
    path: RouteEnum.SURVEY_SUMMARY,
    permissions: ROUTES_PERMISSIONS[RouteEnum.SURVEY_SUMMARY],
  },
  {
    component: TestFillView,
    path: RouteEnum.TEST_FILL,
    permissions: ROUTES_PERMISSIONS[RouteEnum.TEST_FILL],
  },
  {
    component: TestResultView,
    path: RouteEnum.TEST_RESULT,
    permissions: ROUTES_PERMISSIONS[RouteEnum.TEST_RESULT],
  },
  {
    component: TestTermUnavailableView,
    path: RouteEnum.TEST_TERM_UNAVAILABLE,
    permissions: ROUTES_PERMISSIONS[RouteEnum.TEST_TERM_UNAVAILABLE],
  },
  {
    component: ExamineeExamView,
    path: RouteEnum.EXAMINEE_EXAM,
    permissions: ROUTES_PERMISSIONS[RouteEnum.EXAMINEE_EXAM],
  },

  {
    component: ForbiddenView,
    path: RouteEnum.FORBIDDEN,
    permissions: ROUTES_PERMISSIONS[RouteEnum.FORBIDDEN],
  },
];
